<!-- Check if the items length is greater than or equal to 3 -->
<div *ngIf="hasEnoughItems; else singleCards">
  <!-- Carousel display -->
  <p-carousel
    [value]="items"
    [numVisible]="numVisible"
    [numScroll]="numScroll"
    [responsiveOptions]="responsiveOptions"
    [circular]="true">

    <!-- Render the provided template using ngTemplateOutlet -->
    <ng-template pTemplate="item" let-item>
      <ng-container *ngTemplateOutlet="bodyTemplate; context: { $implicit: item }"></ng-container>
    </ng-template>
  </p-carousel>
</div>

<!-- If there are less than 4 items, display the cards directly -->
<ng-template #singleCards>
  <div class="d-flex gap-3">
    <ng-container *ngFor="let item of items">
      <!-- Render the provided template using ngTemplateOutlet -->
      <ng-container *ngTemplateOutlet="bodyTemplate; context: { $implicit: item }"></ng-container>
    </ng-container>
  </div>
</ng-template>
